<template>
  <div>
    <h3 class="md-title">
      <md-icon>trip_origin</md-icon>
      {{ $route.name }}
    </h3>
    <div class="md-layout">
      <div class="md-layout-item md-size-20 no-padding">
        <md-card>
          <md-card-header md-alignment="space-between">
            <h4 class="title">
              <md-icon>publish</md-icon>파일 업로드
            </h4>
          </md-card-header>
          <md-card-content>
            <div class="flex-div">
              <h5 class="title">엑셀 업로드</h5>
              <div class="inline-flex mb10">
                <input v-focus type="file" class="hidden-input-file" id="bundleFileInput" accept=".xlsx">
                <input type="text" v-model="excelFileName" disabled>
                <button @click="onClickSearchExcel">
                  <md-icon>search</md-icon>엑셀 파일 찾기
                </button>
              </div>
              <md-button class="md-success md-sm full-size-button" @click="uploadExcelFile" :disabled="!excelFile">
                <md-icon>publish</md-icon>
                엑셀 업로드
              </md-button>
            </div>
            <hr>
            <div class="flex-div">
              <div class="inline-flex mb10">
                <input type="text" placeholder="회원검색" disabled v-model="inputQuery.memberHnm">
                <button @click="isShowUserModal = true;"><i class="md-icon md-icon-font md-theme-default">search</i></button>
                <select v-model="inputQuery.postFlag">
                  <option value="">주소선택</option>
                  <option value="01">자택</option>
                  <option value="02">직장</option>
                </select>
                <input type="text" v-model="inputQuery.loadDate">
              </div>
              <md-button class="md-success md-sm full-size-button" @click="saveInputQuery">
                <md-icon>publish</md-icon>
                개별등록
              </md-button>
            </div>
          </md-card-content>
        </md-card>
      </div>
      <div class="md-layout-item md-size-80 no-padding">
        <md-card>
          <md-card-header md-alignment="space-between">
            <h4 class="title">
              <md-icon>assignment</md-icon>
              검색 결과
            </h4>
          </md-card-header>
          <md-card-content>
            <div class="table-header-info">
              <div>총 {{ total }} 건의 검색결과가 있습니다.</div>
              <div>
                <select v-model="pagination.perPage" name="pages" @change="perPageChange">
                  <option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
                    {{ item }}
                  </option>
                </select>
              </div>
            </div>

            <grid ref="backpostList"
                  :data="gridProps.data"
                  :columns="gridProps.columns"
                  :options="gridProps.options"
                  :theme="gridProps.theme"
                  :rowHeaders="gridProps.rowHeaders"
                  :columnOptions="gridProps.columnOptions"
                  :language="gridProps.lang"
                  @response="response"
            ></grid>

          </md-card-content>
          <md-card-actions md-alignment="right">
            <md-button class="md-warning md-sm" @click="runBundleUpdate">
              <md-icon>undo</md-icon>미처리 상태 데이터 반송처리
            </md-button>
            <md-button class="md-warning md-sm" @click="deleteBackpost">
              <md-icon>clear</md-icon>
              삭제
            </md-button>
            <md-button class="md-success md-sm" @click="downloadExcel" :disabled="this.pagination.total === 0">
              <md-icon>get_app</md-icon>Excel 다운로드
            </md-button>
          </md-card-actions>
        </md-card>
      </div>

    </div>
    <!--교우검색 팝업 -->
    <member-search-pop-comp :is-show.sync="isShowUserModal" @returnResult="onClickModalMember"></member-search-pop-comp>
  </div>
</template>

<script>
import kuaaApi from "@/kuaa/kuaa-api";
import URL_CONST from "@/kuaa/kuaa-url-const";
import formatter from "@/kuaa/kuaa-formatter";
import kuaaFnc from "@/kuaa/kuaa-comm-func";
import parser from "@/kuaa/kuaa-parser";
import session from "@/kuaa/kuaa-sessions";
import moment from "moment";
import { Grid } from '@toast-ui/vue-grid';
import 'tui-grid/dist/tui-grid.css';
import 'tui-pagination/dist/tui-pagination.css';

import Swal from "sweetalert2";

import { MemberSearchPopComp } from "@/pages"

export default {
  components: {
    grid: Grid,
    MemberSearchPopComp
  },


  created() {
    this.initGrid();
    this.initQueryDate();

  },

  computed: {
    total: function() {
      return this.pagination.total
    }
  },
  data(){
    return{
      excelFile: null,
      excelFileName: null,
      isShowUserModal : false,

      inputQuery : {
        memberNo : null,
        memberHnm : null,
        postFlag : "",
        loadDate : moment().format("YYYY-MM-DD")
        //loadDate : null
      },

      dataSource: {
        withCredentials: false,
        initialRequest: true,
        api: {
          readData: { contentType: 'application/json', url: URL_CONST.GET_BACKPOST_LIST, method: 'POST', initParams: {"statusCd" : "1"} }
        },
        headers: { 'X-Auth-Token': session.get('token') }
      },
      pagination: {
        perPage: 20,
        page: 1,
        perPageOptions: [20, 50, 100, 200, 500],
        total: 0
      }
    };
  },
  methods: {
    clearInputQuery(){
      this.inputQuery = {
        memberNo : null,
        memberHnm : null,
        postFlag : this.inputQuery.postFlag,
        loadDate : moment().format("YYYY-MM-DD")

        //loadDate : null
      }
    }, 
    initQueryDate() {
      let now = moment();
      this.inputQuery.loadDate = now.format("YYYY-MM-DD");
    },
    initGrid() {
      this.gridProps = kuaaFnc.setGridInit(null, true, this.pagination, ['rowNum', 'checkbox']);
      this.gridProps['el'] = this.$refs.backpostList;
      this.gridProps['columns'] = [
          {header: '교우번호', name: 'memberNo', align : 'center', sortable: true},
          {header: '교우명', name: 'memberHnm', align : 'center', sortable: true},
          {header: '한자명', name: 'memberCnm', align : 'center', sortable: true},
          {header: '수령처', name: 'postFlagNm', align : 'center', sortable: true},
          {header: '반송처리일자', name: 'loadDate', align : 'center', sortable: true},
          {header: '발송일자', name: 'backDate', align : 'center', sortable: true},
          {header: '상태', name: 'statusCdNm', align : 'center', sortable: true},
          {header: '일련번호', name: 'seqNo', hidden : true}
        ];
      this.gridProps['data'] = this.dataSource;
      this.gridProps['options'].bodyHeight = 500;
    },
    response(e) {
      let res = JSON.parse(e.xhr.response);
      if(res.result){
        this.pagination.total = res.data.pagination.totalCount;
      }else{
        kuaaFnc.gridErrorCallback(e,"우편물 반송처리");
      }
    },
    perPageChange(event) {
      kuaaFnc.resetPagenation(this.$refs.backpostList, event, this.pagination);
    },

    searchList() {
      this.$refs.backpostList.invoke("readData", 1, {"statusCd" : "1"});
    },

    onClickSearchExcel() {
      let input = document.getElementById("bundleFileInput");
      input.onchange = e => {
        let file = e.target.files[0];
        this.excelFileName = file.name;
        this.excelFile = file;
      };
      input.click();
    },

    uploadExcelFile() {
      let xls = this.excelFile;
      parser.parseXlsBackPostData(xls, (res)=>{
        this.saveExcelFileData(res)
      });
    },

    saveExcelFileData(list){
      let modalOptions = kuaaFnc.getSwalModaloptions('confirm',{
        title: "일괄 업데이트",
        html: "서버에 전송 하시겠습니까?",
      });

      if(!list.length){
        return;
      }

      Swal.fire(modalOptions).then(result => {
        if (result.value) {

          kuaaApi.sendServer(
            URL_CONST.SAVE_BACKPOST_STATUS_LIST,
            list,
            "post",
            response => {
              if (response.data.success){
                modalOptions.html = `일괄 저장 되었습니다.`;
                modalOptions.showCancelButton = false;
                modalOptions.confirmButtonText = "확인";
                Swal.fire(modalOptions);
                this.searchList();
              } else {
                modalOptions.html = `일괄 저장 실패 하였습니다.`;
                Swal.fire(modalOptions);
              }
            }
          );

        }
      });

    },

    // 일괄 등록 서버에 전송
    runBundleUpdate(){
      let rows = this.$refs.backpostList.invoke("getData")

      if(!rows.length){
        return;
      }


      let modalOptions = kuaaFnc.getSwalModaloptions('confirm',{
        title: "일괄 업데이트",
        html: "서버에 전송 하시겠습니까?",
      });

      Swal.fire(modalOptions).then(result => {
        if (result.value) {

          let params = [];
          rows.forEach((obj)=>{
            params.push({
              memberNo : obj.memberNo,
              seqNo : obj.seqNo
            })
          });

          kuaaApi.sendServer(
            URL_CONST.UPDATE_BACKPOST_STATUS_LIST,
            params,
            "post",
            response => {
              if (response.data.success){
                modalOptions.html = `일괄 업데이트 되었습니다.`;
                modalOptions.showCancelButton = false;
                modalOptions.confirmButtonText = "확인";
                Swal.fire(modalOptions);
                this.searchList();
              } else {
                modalOptions.html = `일괄 업데이트 실패 하였습니다.`;
                Swal.fire(modalOptions);
              }
            }
          );

        }
      });
    },

    onClickModalMember(item){
      this.inputQuery.memberNo = item.memberNo;
      this.inputQuery.memberHnm = item.memberHnm;
    },

    saveInputQuery(){
      if(!this.inputQuery.memberNo || !this.inputQuery.postFlag  || !this.inputQuery.loadDate){
        Swal.fire(kuaaFnc.getSwalModaloptions({html:'모든 항목을 입력 해 주세요'}))
        return false;
      }
      if(!moment(this.inputQuery.loadDate, 'YYYY-MM-DD').isValid()){
        Swal.fire(kuaaFnc.getSwalModaloptions({html:'반송일자가 유효하지 않습니다.'}));
        return false;
      }
      let modalOptions = kuaaFnc.getSwalModaloptions('confirm',{
        title: "개별등록",
        html: "저장 하시겠습니까?",
      });

      Swal.fire(modalOptions).then(result => {
        if (result.value) {
          let params = JSON.parse(JSON.stringify(this.inputQuery));
          params['loadDate'] = kuaaFnc.cleanDateFormatter(params['loadDate']);
          kuaaApi.sendServer(
            URL_CONST.SAVE_BACKPOST_LIST,
            params,
            "post",
            response => {
              if (response.data.success){
                modalOptions.html = `저장 되었습니다.`;
                Swal.fire(modalOptions);
                this.clearInputQuery();
                this.searchList();
              } else {
                modalOptions.html = `저장 실패 하였습니다.`;
                Swal.fire(modalOptions);
              }
            }
          );

        }
      });
    },

    deleteBackpost() {
      let selectedRows = this.$refs.backpostList.invoke('getCheckedRows');

      if(!selectedRows.length){
        Swal.fire(kuaaFnc.getSwalModaloptions({html:'삭제할 대상을 선택해 주세요'}));
        return;
      }

      let modalOptions = kuaaFnc.getSwalModaloptions('confirm',{
        title: "우편물 반송처리",
        html: "삭제 하시겠습니까?",
      });

      Swal.fire(modalOptions).then(result => {
        if (result.value) {
          kuaaApi.sendServer(
              URL_CONST.DELETE_BACKPOST_LIST,
              selectedRows,
              "post",
              response => {
                if (response.data.success){
                  modalOptions.html = `삭제 되었습니다.`;
                  Swal.fire(kuaaFnc.getSwalModaloptions({html:'삭제 되었습니다.'}));
                  this.searchList();
                } else {
                  Swal.fire(kuaaFnc.getSwalModaloptions({html:'삭제중 오류가 발생 되었습니다.'}));
                }
              }
          );

        }
      });

    },

    downloadExcel() {
      if(this.pagination.total == 0){
        kuaaFnc.showSwal("엑셀 다운로드", "다운로드할 데이타가 존재하지 않습니다.");
        return false;
      }
      let query = {
        page: 1,
        perPage: this.pagination.total,
        statusCd: "1",
        fileName: '우편물 반송처리'
      }
      kuaaApi.requestFileDownload(
          URL_CONST.BACKPOST_EXCEL_DOWNLOAD,
          query,
          '우편물반송처리.xlsx',
          response => {

          }
      );
    }
  }
};
</script>

<style>

</style>